module.exports = __webpack_public_path__ + "static/ocean-robbins-square.dbb8aaad.jpg";